"use strict";

(function ($, Drupal) {
  Drupal.behaviors.noResults = {
    attach: function attach() {
      // Check if there is any li in the ul of the newsroom
      // if not then show "NO RESULTS FOUND".
      if ($('.newsroom-section .left-section ul').find('li').length) {
        // console.log("true");
      } else {
        // console.log("false");
        $('.newsroom-section .left-section ul').html('<li><div>No Results Found</div></li>');
      }
      // Check if there is any li in the ul of the Events
      // if not then show "NO RESULTS FOUND".
      if ($('ul.event-list li').children().length == 0) {
        $('ul.event-list').children('.views-element-container').append('<div class="views-row"><li><h3>No Results Found</h4></li></div>');
      }
    }
  };
})(jQuery, Drupal);